import type { HearingParticipant } from 'features/call/call-hearing/interfaces';

export const clearTeardownMarkers = (hearing: HearingParticipant) => {
  hearing.teardownIntent = undefined;
  hearing.teardownDeadlineAt = undefined;
  hearing.lastTeardownReason = undefined;
};
